module.exports = __webpack_public_path__ + "img/ics_f_star.cdce2ea6.svg";